module.exports = __webpack_public_path__ + "static/media/logo_xicaes.2542cd06.png";